import { styled } from '@uhg-abyss/web/tools/styled';

export const Styles = styled('div', {
  '.apexcharts-svg': {
    overflow: 'visible',
  },
  '#chart': {
    height: 'inherit',
    maxHeight: 'inherit',
    minHeight: 'inherit',
    overflow: 'hidden',
    paddingBottom: 'var(--abyss-space-sm)',
    paddingTop: 'var(--abyss-space-md)',
    position: 'relative',
  },
  height: 'inherit',
  maxHeight: 'inherit',
  minHeight: 'inherit',
  position: 'relative',
});
